/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Banner_SpaceInputs */

const en_lifecycle_banner_space = /** @type {(inputs: Lifecycle_Banner_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This space is archived. It and its products are read-only and hidden from the sidebar, lists and search.`)
};

const de_lifecycle_banner_space = /** @type {(inputs: Lifecycle_Banner_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Bereich ist archiviert. Er und seine Produkte sind schreibgeschützt und in Seitenleiste, Listen und Suche ausgeblendet.`)
};

/**
* | output |
* | --- |
* | "This space is archived. It and its products are read-only and hidden from the sidebar, lists and search." |
*
* @param {Lifecycle_Banner_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_banner_space = /** @type {((inputs?: Lifecycle_Banner_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Banner_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_banner_space(inputs)
	return en_lifecycle_banner_space(inputs)
});